<div>
    <app-vwsa-text text="{{statusMessage}}" appearance="headline250" weight="bold"></app-vwsa-text>
    <!--info-->
    <div [hidden]="!infoLoaded">
        <br />
        <!--successful purchase-->
        <div [hidden]="!visibleElements['PaymentSuccess']">
            <app-vwsa-text text="Your EasyDrive Vehicle Plan has been added to your customer details, but it may take up to 24 hours to reflect on the system.">
            </app-vwsa-text>
            <br />
            <div class="column__list" *ngIf="transaction">
                <div class="card__list">
                    <app-vwsa-text-input inputId="payment_quote_ref" label="Contract Number" value="{{transaction?.sapContractNumber}}" disabled="true">
                    </app-vwsa-text-input>
                </div>
                <div class="card__list">
                    <app-vwsa-text-input inputId="payment_total" label="Total (incl. VAT)" value="R{{transaction?.newPlanTotalIncludingVat | number}}" disabled="true">
                    </app-vwsa-text-input>
                </div>
            </div>
            <app-vwsa-button text="View My Details" (click)="onViewMyDetails()" [disabled]="!ownerInfo">
            </app-vwsa-button>
            <br /><br />
            <app-vwsa-text text="You can download a copy of the EasyDrive contract for your records. A copy will also be emailed to the address provided.">
            </app-vwsa-text>
            <br />
            <app-vwsa-button text="Download Contract" (click)="onDownloadContractPdf()" [disabled]="!transaction">
            </app-vwsa-button>
            <br /><br />
            <app-vwsa-text text="If you still have any questions or need help with anything, please contact our Customer Care Centre. Please have your contract number on hand: {{transaction?.sapContractNumber}}

            South Africa: 0860 434 737
            Swaziland, Lesotho, Namibia and Botswana: +27 41 994 5615"></app-vwsa-text>
        </div>
        <!--unsuccessful purchase-->
        <div [hidden]="!visibleElements['PaymentFailure']">
            <app-vwsa-text text="Unfortunately your bank has declined the transaction and it cannot be completed. This could be due to a number of reasons and we recommend you contact your bank.

                You have not been billed.
                
                If you would like to choose a different EasyDrive Vehicle Plan please click here:">
            </app-vwsa-text>
            <br />
            <app-vwsa-button text="View Quotation" (click)="onShowViewQuote()" [disabled]="!ownerInfo">
            </app-vwsa-button>
            <br /><br />
            <app-vwsa-text text="If you still have any questions or need help with anything, please contact our Customer Care Centre.

            South Africa: 0860 434 737
            Swaziland, Lesotho, Namibia and Botswana: +27 41 994 5615"></app-vwsa-text>
        </div>
        <!--User Cancelled-->
        <div [hidden]="!visibleElements['UserCancelled']">
            <app-vwsa-text text="The transaction has been cancelled and you have not been billed.

            If you would like to choose a different EasyDrive Vehicle Plan please click here:"></app-vwsa-text>
            <br />
            <app-vwsa-button text="Select Plan" (click)="onShowSelectPlan()" [disabled]="!ownerInfo">
            </app-vwsa-button>
            <br /><br />
            <app-vwsa-text text="If you still have any questions or need help with anything, please contact our Customer Care Centre.

            South Africa: 0860 434 737
            Swaziland, Lesotho, Namibia and Botswana: +27 41 994 5615"></app-vwsa-text>
        </div>
        <!--PayU Error-->
        <div [hidden]="!visibleElements['PayUError']">
            <app-vwsa-text
                text="Unfortunately we can’t confirm your transaction at this time. You should receive an email confirming your new EasyDrive contract within the hour, but if for some reason there is a problem, our team will be in contact with you.">
            </app-vwsa-text>
            <br />
            <app-vwsa-text text="If you still have any questions or need help with anything, please contact our Customer Care Centre.

            South Africa: 0860 434 737
            Swaziland, Lesotho, Namibia and Botswana: +27 41 994 5615"></app-vwsa-text>
        </div>
        <!--PayU Timeout-->
        <div [hidden]="!visibleElements['PayUTimeout']">
            <app-vwsa-text text="The transaction has timed out.

            If you would like to choose a different EasyDrive Vehicle Plan please click here:"></app-vwsa-text>
            <br />
            <app-vwsa-button text="Select Plan" (click)="onShowSelectPlan()" [disabled]="!ownerInfo">
            </app-vwsa-button>
            <br /><br />
            <app-vwsa-text text="If you still have any questions or need help with anything, please contact our Customer Care Centre.

            South Africa: 0860 434 737
            Swaziland, Lesotho, Namibia and Botswana: +27 41 994 5615"></app-vwsa-text>
        </div>
    </div>
    <div *ngIf="visibleElements['CancelContract']">
        <br />
        <app-vwsa-button text="Cancel Contract" (click)="onCancelContract()" [disabled]="!transaction">
        </app-vwsa-button>
    </div>
    <div *ngIf="visibleElements['RefundTransaction']">
        <br />
        <app-vwsa-button text="Refund Transaction" (click)="onRefundTransaction()" [disabled]="!transaction">
        </app-vwsa-button>
    </div>
</div>